import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, useFirestore } from '../lib/firebase';
import { useAuth } from '../context/AuthContext';

/** Reactive "is Gmail connected" flag, backed by `googleConnections/{uid}`
 *  (set by the `connectGoogleAccount`/`disconnectGoogleAccount` callables). */
export function useGoogleConnection(): boolean {
  const { user } = useAuth();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!useFirestore || !db || !user) return;
    return onSnapshot(doc(db, 'googleConnections', user.uid), (snap) => {
      setConnected(Boolean(snap.data()?.connected));
    });
  }, [user]);

  // Reset immediately (not from inside the effect) when there's no signed-in
  // user to subscribe for, e.g. after sign-out.
  if (!user && connected) setConnected(false);

  return connected;
}
